import { render, staticRenderFns } from "./AddExamObject.vue?vue&type=template&id=1640c5e6&scoped=true&"
import script from "./AddExamObject.vue?vue&type=script&lang=js&"
export * from "./AddExamObject.vue?vue&type=script&lang=js&"
import style0 from "./AddExamObject.vue?vue&type=style&index=0&id=1640c5e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640c5e6",
  null
  
)

export default component.exports